export function isEmptyObject(obj: any): boolean {
  return !obj || Object.keys(obj).length === 0;
}

export function getProperty(obj: any, path: string): any {
  if (!path || !obj) {
    return null;
  }

  return path
    .split('.')
    .reduce((result, prop) => (result == null ? undefined : result[prop]), obj);
}

export function setAllObjectKeys(
  obj: any,
  val: any,
  exceptionList?: string[]
): void {
  Object.keys(obj).forEach((key) => {
    if (!exceptionList || !exceptionList.includes(key)) {
      obj[key] = val;
    }
  });
}

export function isNullOrUndefined(obj: any): boolean {
  return obj === null || obj === undefined;
}
